/**
 * Created by mukund on 8/25/17.
 */
angular.module('mediacloudApp')
    .directive('lmsThumbnails', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/lms/directives/thumbnail/thumbnail.html',
            scope: {
                file: '='
            }
        }

    });
